export const getItemCount = state => state.search.itemCount;
